/* ==========================================================================
   assets/pnt-search.js
   Buscador + filtros + selector Notebook/All in One — EXCLUSIVO de la
   colección Pantallas (/collections/pantallas-de-notebook).
   No toca theme.js, Predictive Search ni el buscador global.
   Filtra client-side sobre las tarjetas reales renderizadas por
   sections/pnt-grid.liquid. Da prioridad a metafields cuando existen;
   si no existen, usa solo datos reales (título, SKU, vendor, tags,
   descripción) — nunca infiere características no confirmadas.
   ========================================================================== */
(function () {
  "use strict";

  function init() {
  var grid = document.querySelector("[data-pnt-grid]");
  if (!grid) return; // esta página no es la colección de Pantallas

  var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-pnt-card]"));
  var searchInput = document.querySelector("[data-pnt-search-input]");
  var searchSubmit = document.querySelector("[data-pnt-search-submit]");
  var typeButtons = Array.prototype.slice.call(document.querySelectorAll("[data-pnt-type]"));
  var filterSelects = Array.prototype.slice.call(document.querySelectorAll("[data-pnt-filter-select]"));
  var chips = Array.prototype.slice.call(document.querySelectorAll("[data-pnt-chip]"));
  var clearBtn = document.querySelector("[data-pnt-clear]");
  var countEl = document.querySelector("[data-pnt-count]");
  var gridCountEl = document.querySelector("[data-pnt-grid-count]");
  var emptyEl = document.querySelector("[data-pnt-grid-empty]");

  var state = {
    type: "all",
    query: "",
    filters: { size: "", resolution: "", technology: "", panel: "", pins: "", refresh: "", formFactor: "", connector: "" }
  };

  /* -------------------- Normalización (solo para EMPAREJAR, no altera datos) -------------------- */
  function stripAccents(s) {
    return s.normalize ? s.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : s;
  }

  function normalize(s) {
    if (!s) return "";
    return stripAccents(String(s).toLowerCase()).replace(/\s+/g, " ").trim();
  }

  function normalizeSize(s) {
    var n = normalize(s).replace(/"/g, "");
    n = n.replace(/(\d+)[,\s](\d)/, "$1.$2"); // "15,6" / "15 6" -> "15.6"
    return n.trim();
  }

  function normalizePins(s) {
    var n = normalize(s);
    var m = n.match(/(\d+)\s*pin(es|s)?\b/) || n.match(/(\d+)\s*p\b/);
    return m ? m[1] + " pines" : n;
  }

  var RESOLUTION_GROUPS = [
    { key: "hd", terms: ["hd"] },
    { key: "hd+", terms: ["hd+", "hd plus"] },
    { key: "fhd", terms: ["fhd", "full hd", "1920x1080", "1080p"] },
    { key: "qhd", terms: ["qhd", "2k"] },
    { key: "2.5k", terms: ["2.5k", "2,5k"] },
    { key: "3k", terms: ["3k"] },
    { key: "4k", terms: ["4k", "uhd"] }
  ];

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeResolution(s) {
    var n = normalize(s);
    if (!n) return "";
    for (var i = 0; i < RESOLUTION_GROUPS.length; i++) {
      var g = RESOLUTION_GROUPS[i];
      for (var j = 0; j < g.terms.length; j++) {
        var term = g.terms[j];
        // Coincidencia de palabra completa: "hd" NO debe matchear dentro de "fhd"
        var re = new RegExp("(^|[^a-z0-9])" + escapeRegExp(term) + "([^a-z0-9]|$)");
        if (n === term || re.test(n)) return g.key;
      }
    }
    return n;
  }

  function normalizePartNumber(s) {
    // Ignora diferencias menores de escritura (espacios, guiones, puntos) SOLO para comparar
    return normalize(s).replace(/[\s\-.]+/g, "");
  }

  /* -------------------- Leer los datos reales de cada tarjeta -------------------- */
  function readCard(card) {
    var d = card.dataset;
    return {
      el: card,
      title: normalize(d.title),
      sku: normalize(d.sku),
      vendor: normalize(d.vendor),
      tags: normalize(d.tags),
      description: normalize(d.description),
      tipoEquipo: d.tipoEquipo || "",
      size: d.size || "",
      resolution: d.resolution || "",
      pins: d.pins || "",
      panel: d.panel || "",
      technology: d.technology || "LCD/LED",
      refresh: d.refresh || "",
      connector: d.connector || "",
      partNumber: d.partNumber || "",
      manufacturerModel: d.manufacturerModel || "",
      compatiblePn: d.compatiblePn || "",
      compatibleModels: d.compatibleModels || "",
      manufacturer: normalize(d.manufacturer),
      mounting: normalize(d.mounting),
      formFactor: normalize(d.formFactor),
      touch: normalize(d.touch),
      sortTipo: d.sortTipo || "1",
      sortSize: parseFloat(d.sortSize) || 999
    };
  }

  var indexed = cards.map(readCard);

  // Orden comercial por defecto (sección 27): Notebook antes que All in One,
  // luego por tamaño ascendente. Se aplica una sola vez al cargar; los
  // resultados de búsqueda con texto se reordenan aparte, por relevancia.
  indexed.slice().sort(function (a, b) {
    if (a.sortTipo !== b.sortTipo) return a.sortTipo < b.sortTipo ? -1 : 1;
    return a.sortSize - b.sortSize;
  }).forEach(function (item) {
    grid.appendChild(item.el);
  });

  /* -------------------- Poblar filtros SOLO con valores reales presentes -------------------- */
  function populateFilter(select, field) {
    var seen = {};
    var values = [];
    indexed.forEach(function (c) {
      var v = c[field];
      if (v && !seen[v]) {
        seen[v] = true;
        values.push(v);
      }
    });
    values.sort();
    values.forEach(function (v) {
      var opt = document.createElement("option");
      opt.value = v;
      opt.textContent = v;
      select.appendChild(opt);
    });
    // Si no hay ningún valor real todavía (sin metafields cargados), deshabilitar
    if (values.length === 0) {
      select.disabled = true;
      select.closest("[data-pnt-filter]").style.opacity = "0.45";
    }
  }

  filterSelects.forEach(function (select) {
    populateFilter(select, select.getAttribute("data-pnt-filter-select"));
  });

  /* -------------------- Scoring de UN término contra una tarjeta (orden de prioridad) -------------------- */
  function singleTermScore(c, qRaw) {
    var q = normalize(qRaw);
    if (!q) return 0;
    var qPn = normalizePartNumber(qRaw);
    var qSize = normalizeSize(qRaw);
    var qPins = normalizePins(qRaw);
    var qRes = normalizeResolution(qRaw);
    var score = 0;

    // 1. P/N exacto
    if (c.partNumber && normalizePartNumber(c.partNumber) === qPn) score += 100;
    // 2. P/N equivalente (lista de compatibles)
    else if (c.compatiblePn && normalizePartNumber(c.compatiblePn).indexOf(qPn) !== -1 && qPn.length >= 4) score += 80;

    // 3. Modelo del fabricante
    if (c.manufacturerModel && normalize(c.manufacturerModel).indexOf(q) !== -1) score += 60;

    // 4. Modelo de notebook/AIO compatible
    if (c.compatibleModels && normalize(c.compatibleModels).indexOf(q) !== -1) score += 50;

    // 5. SKU HPPARTES
    if (c.sku && c.sku.indexOf(q) !== -1) score += 40;

    // 6-9. Tamaño / resolución / tecnología (OLED/AMOLED) / pines / panel / frecuencia (si hay metafield)
    if (c.size && normalizeSize(c.size) === qSize) score += 30;
    if (c.resolution && normalizeResolution(c.resolution) === qRes) score += 28;
    if (c.technology && normalize(c.technology) === q) score += 32; // OLED/AMOLED — palabra exacta, no parcial
    if (c.pins && normalizePins(c.pins) === qPins) score += 26;
    if (c.panel && normalize(c.panel) === q) score += 24;
    if (c.refresh && normalize(c.refresh).indexOf(q) !== -1) score += 20;

    // 10. Texto general (título, vendor, tags, descripción) — prioridad más baja
    if (c.title.indexOf(q) !== -1) score += 10;
    if (c.vendor.indexOf(q) !== -1) score += 6;
    if (c.tags.indexOf(q) !== -1) score += 6;
    if (c.manufacturer && c.manufacturer.indexOf(q) !== -1) score += 6;
    if (c.mounting && c.mounting === q) score += 6;
    if (c.formFactor && c.formFactor === q) score += 6;
    if (c.touch && c.touch === q) score += 6;
    if (c.description.indexOf(q) !== -1) score += 2;

    return score;
  }

  /* -------------------- Búsqueda AND por tokens: "15.6 IPS 30" exige los 3 -------------------- */
  function queryScore(c, qRaw) {
    var tokens = normalize(qRaw).split(/\s+/).filter(function (t) { return t.length > 0; });
    if (tokens.length === 0) return 0;
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var s = singleTermScore(c, tokens[i]);
      if (s === 0) return 0; // AND: si un término no matchea en ningún campo, el producto queda afuera
      total += s;
    }
    return total;
  }

  /* -------------------- Aplicar filtros + tipo + búsqueda -------------------- */
  function matchesFilters(c) {
    if (state.type !== "all" && c.tipoEquipo && c.tipoEquipo !== state.type) return false;
    if (state.type !== "all" && !c.tipoEquipo) return false; // sin tipo_equipo aún -> solo visible en "Todos"

    for (var field in state.filters) {
      var val = state.filters[field];
      if (val && c[field] !== val) return false;
    }
    return true;
  }

  function applyState() {
    var visibleCount = 0;
    var scored = indexed.map(function (c) {
      var passFilters = matchesFilters(c);
      var score = state.query ? queryScore(c, state.query) : 1;
      var visible = passFilters && score > 0;
      return { c: c, visible: visible, score: score };
    });

    // Si hay búsqueda activa, reordenar por score descendente (mayor prioridad primero)
    if (state.query) {
      scored.sort(function (a, b) { return b.score - a.score; });
      scored.forEach(function (item) {
        grid.appendChild(item.c.el);
      });
    }

    scored.forEach(function (item) {
      item.c.el.hidden = !item.visible;
      if (item.visible) visibleCount++;
    });

    if (countEl) countEl.textContent = visibleCount;
    if (gridCountEl) {
      gridCountEl.textContent = visibleCount === 1 ? "1 pantalla" : visibleCount + " pantallas";
    }
    if (emptyEl) emptyEl.hidden = visibleCount !== 0;
  }

  /* -------------------- Eventos -------------------- */
  function runSearch() {
    state.query = searchInput ? searchInput.value.trim() : "";
    applyState();
  }

  if (searchSubmit) searchSubmit.addEventListener("click", runSearch);
  if (searchInput) {
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") runSearch();
    });
  }

  typeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      typeButtons.forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      state.type = btn.getAttribute("data-pnt-type");
      applyState();
    });
  });

  filterSelects.forEach(function (select) {
    select.addEventListener("change", function () {
      var field = select.getAttribute("data-pnt-filter-select");
      state.filters[field] = select.value;
      applyState();
    });
  });

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var value = chip.getAttribute("data-pnt-chip");
      var isActive = chip.classList.contains("is-active");
      chips.forEach(function (c) { c.classList.remove("is-active"); });
      if (isActive) {
        state.query = "";
        if (searchInput) searchInput.value = "";
      } else {
        chip.classList.add("is-active");
        state.query = value;
        if (searchInput) searchInput.value = value;
      }
      applyState();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      state.type = "all";
      state.query = "";
      for (var f in state.filters) state.filters[f] = "";

      typeButtons.forEach(function (b) { b.classList.remove("is-active"); });
      var allBtn = document.querySelector('[data-pnt-type="all"]');
      if (allBtn) allBtn.classList.add("is-active");

      if (searchInput) searchInput.value = "";
      filterSelects.forEach(function (s) { s.value = ""; });
      chips.forEach(function (c) { c.classList.remove("is-active"); });

      applyState();
    });
  }

  applyState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
